import { FunctionComponent, useEffect, useState } from 'react';
import { Document } from '@prismicio/client/types/documents';
import Header from 'components/Header';
import Footer from 'components/Footer';
import { useRouter } from 'next/router';
import { useAnalytics } from 'hooks/useAnalytics';
import { getPath } from 'utils/paths';

interface Props {
  header?: Document;
  footer?: Document;
  resolver?;
  product?: any;
}

const Layout: FunctionComponent<Props> = ({
  children, header, footer, resolver, product,
}) => {
  const router = useRouter();
  const { page } = useAnalytics();
  const [route, setRoute] = useState<string | null>(null);

  useEffect(() => {
    if (!router.route) return;
    if (router.route) setRoute(router.route);
  }, [router.route]);

  useEffect(() => {
    if (!route) return;
    const { name } = getPath(route);
    page(name, product || undefined);
  }, [route]);

  return (
    <div className="min-h-screen bg-white">
      <Header data={header} resolver={resolver} />
      <main>{children}</main>
      <Footer data={footer} />
    </div>
  );
};

export default Layout;
